import { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Backdrop, CircularProgress, Fade, Grid } from '@mui/material';
import { DashboardContext } from 'contexts/DashboardContext';
import Container from 'components/Container';
import ApontamentosDeHoje from './Widgets/ApontamentosDeHoje';
import OrdensPorStatus from './Widgets/OrdensPorStatus';
import OrdensPendentes from './Widgets/OrdensPendentes';
import AtrasosNaProducao from './Widgets/AtrasosNaProducao';
import ConformidadesPorSetor from './Widgets/ConformidadesPorSetor';
import CapacidadeDoMes from './Widgets/CapacidadeDoMes';
import styles from './styles';
import LeadTimeDoMes from './Widgets/LeadTimeDoMes';
import ParadasNaProducao from './Widgets/ParadasNaProducao';

const App = () => {
  const defaultValues = {};
  const [dashboard, setDashboard] = useState(null);
  const { getLoading, getDashboard } = useContext(DashboardContext);
  const { control, handleSubmit } = useForm({ defaultValues });

  const loadData = (params) => getDashboard({ params, cb: setDashboard });

  useEffect(() => {
    handleSubmit(loadData)();
  }, []);

  return (
    <Container>
      <Grid container rowSpacing={10} columnSpacing={5} alignItems="stretch">
        <OrdensPorStatus data={dashboard?.ordens_por_status} />
        {/* GRAFICO NOVO */}
        <OrdensPendentes data={dashboard?.ordens_pendentes} />
        <ApontamentosDeHoje data={dashboard?.apontamentos_de_hoje} />
        <LeadTimeDoMes data={dashboard?.lead_time_do_mes} />
        <ParadasNaProducao data={dashboard?.paradas_na_producao} />
        <AtrasosNaProducao data={dashboard?.atrasos_na_producao} />
        <ConformidadesPorSetor data={dashboard?.conformidades} />
        <CapacidadeDoMes data={dashboard?.capacidade_do_mes} />
      </Grid>
      <Fade in={getLoading}>
        <Backdrop open={getLoading} sx={styles?.loader}>
          <CircularProgress color="inherit" size={48} thickness={4} />
        </Backdrop>
      </Fade>
    </Container>
  );
};

export default App;
